<h4 class="stepper-page-title title-2 mb-4">Documents</h4>
<form class="request-documents" [formGroup]="documentsForm">
  <p-panel
    [toggleable]="false"
    header={{header}}
  >
    @if (isExternal) {
      <div class="mb-6">
        <div class="mb-6">
          <strong>Please make sure that all available documentation required for review is attached to the
            request:</strong>
        </div>
        @if (isHhAuthForPacUser) {
          <div data-test-id="hh-pac-accepted-documents">
            <p class="font-semibold">Accepted Documents:</p>
            <ul class="list-disc pl-10 my-4">
              <li class="mb-2">Face sheet (Demo info)</li>
              <li class="mb-2">Physician order</li>
              <li class="mb-2">Clinical Documentation</li>
              <li class="mb-2">Other</li>
            </ul>
          </div>
        } @else {
        <div class="flex gap-4">
          <div class="flex-1 left-list-container">
            <div class="mb-6 p-4 list-header">Initial Request</div>
            <p class="mb-6 pl-4">Provider Orders—including frequency, duration, Provider Name, and NPI</p>
            <p class="mb-6 pl-4">Recent clinical Information for the member</p>
            <p class="mb-6 pl-4">Records sent with a referral from a referral source</p>
            <div class="mb-6 p-4 list-header">For Wound Request</div>
            <p class="mb-6 pl-4">SN notes from the past two weeks—including comprehensive wound assessment and
              measurements for each wound</p>
          </div>
          <div class="flex-1 right-list-container">
            <div class="mb-6 p-4 list-header">Subsequent Request</div>
            <p class="mb-6 pl-4">Plan of Care/485</p>
            <p class="mb-6 pl-4">OASIS</p>
            <p class="mb-6 pl-4">Original discipline-specific evaluations</p>
            <p class="mb-6 pl-4">Provider Orders—including frequency, duration, Provider Name, and NPI</p>
            <p class="mb-6 pl-4">Most recent discipline-specific visit notes</p>
          </div>
        </div>
        }
      </div>
    }

    <div class="p-formgrid p-form-widget p-form-view-data space-y-6">
      @if (!isPASCompleteFlow && !isHhAuthForPacUser) {
        <div class="flex items-center gap-4">
          <label class="font-semibold">Are you uploading an OASIS with your request?</label>
          <div class="p-field-value">
            <div class="flex gap-4">
              <div class="flex items-center">
                <p-radio-button name="uploadOasis" value="Yes" inputId="uploadOasis_yes"
                                formControlName="uploadOasis" />
                <label for="uploadOasis_yes" class="ml-2">Yes</label>
              </div>
              <div class="flex items-center">
                <p-radio-button name="uploadOasis" value="No" inputId="uploadOasis_no" formControlName="uploadOasis" />
                <label for="uploadOasis_no" class="ml-2">No</label>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="flex flex-wrap items-center gap-6">
        <div class="flex items-center gap-4">
          <label class="font-semibold" [class.field-required]="isHhAuthForPacUser">Order Type:</label>
          <div class="p-field-value">
            <div class="flex gap-4">
              <div class="flex items-center">
                <p-radio-button
                  name="dateType"
                  value="signedOrder"
                  inputId="dateType_signed"
                  formControlName="dateType"
                  (onClick)="deselectdateType($event)"
                />
                <label for="dateType_signed" class="ml-2">Signed Order</label>
              </div>
              <div class="flex items-center">
                <p-radio-button
                  name="dateType"
                  value="verbalOrder"
                  inputId="dateType_verbal"
                  formControlName="dateType"
                  (onClick)="deselectdateType($event)"
                />
                <label for="dateType_verbal" class="ml-2">Verbal Order</label>
              </div>
            </div>
          </div>
        </div>

        @if (documentsForm?.controls.dateType.value) {
          <div class="flex items-center gap-4">
            <label class="field-required font-semibold">{{ orderDateTypeLabel }} Date</label>
            <div class="p-field-value">
              <p-date-picker formControlName="signedVerbalOrderDate" />
            </div>
          </div>
        }

        @if (documentsForm?.controls.dateType.value === 'verbalOrder' && isPASCompleteFlow) {
          <div class="pt-2 px-2 -mb-2">
            <div class="field">
              <label class="field-required">Ordering Physician Name</label>
              <div class="p-field-value">
                <input type="text" pInputText formControlName="verbalOrderingPhysician" maxlength="150"
                       data-test-id="claim-value" />
              </div>
            </div>
          </div>
        }
      </div>

      @if (!isPASCompleteFlow && !isHhAuthForPacUser) {
        <div class="flex items-center gap-4">
          <p-checkbox
            formControlName="historyAndPhysical"
            binary="true"
            (onChange)="deselectOtherType($event)"
          />
          <label class="font-semibold">Clinical Documentation</label>
        </div>
        <div class="text-red-400">
          If you do not have a signed or verbal order or any clinical
          documentation to attach, please select “I do not have any of these” below.
        </div>
        <div class="p-2 no-option">
          <div class="field">
            <div class="flex gap-4">
              <p-checkbox formControlName="noOrder" binary="true" (onChange)="deselectType($event)"></p-checkbox>
            </div>
            <label>I do not have any of these</label>
          </div>
          <div>
            <strong>Note:</strong> A signed order is required per CMS before billing but may also be uploaded now.
          </div>
        </div>
        <ul class="list-disc ps-8 mb-4">
          <li>
            Requests initiated by Health Plan case managers must also include
            a signed AOR,or other appropriate supporting documents, that
            indicate that you are an authorized representative of the member.
          </li>
          <li>
            You can upload up to 4 files with a total size of 20,480 KB.
            If needed, you can upload additional files from the Authorization
            Details view by clicking the Upload Documents
            button under the Documents menu on the left side.
          </li>
        </ul>
      }
    </div>
    @if (isHhAuthForPacUser) {
      <p-panel class="mt-6" header="Attachments" [toggleable]="false" data-test-id="hh-pac-attachments">
        <p>You can upload up to 4 files with a total size of 20,480 KB. </p>
        <p class="mb-4">
          If needed, you can upload additional files from the Authorization Details view by clicking
          the Upload Documents button under the Document menu on the left side.
        </p>
        <ng-container *ngTemplateOutlet="documentsUpload" />
      </p-panel>
    } @else if (!isPASCompleteFlow) {
      <ng-container *ngTemplateOutlet="documentsUpload" />
    }
  </p-panel>
</form>

<ng-template #documentsUpload>
  <documents-upload
    [isExternal]="isExternal"
    [dateTimeFaxReceivedUTC]="dateTimeFaxReceivedUTC"
    [documents]="uploadedFiles"
    [authorizationNumber]="authRequest.authorizationDTO.authorizationNumber"
    [authorizationId]="authRequest.authorizationDTO.authorizationId"
    [tenantId]="tenantId"
    [tenantName]="tenantName"
    [autoUpload]="true"
    [isHhAuthForPacUser]="isHhAuthForPacUser"
    (uploadedNewFile)="loadFiles($event)"
  >
  </documents-upload>
</ng-template>
